module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "player px-4"
  }, [_c('div', {
    staticClass: "display-flex align-center justify-space-between pt-5 pb-4"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/dot.svg"),
      "width": "27"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'DiscoverMobile'
        })
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require('@/assets/ys_logo_primary-black.svg'),
      "width": "100"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/arrow-down-white.svg"),
      "width": "27"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'DiscoverMobile'
        })
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "track-list mb-2"
  }, [_c('div', {
    staticClass: "text-Poppins-15 font-weight-600 text-white mb-2"
  }, [_vm._v("\n      Tracklist\n    ")]), _vm._v(" "), _vm._l((_vm.playList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "display-flex align-center gap-15 my-2 track-list__item",
      class: {
        'is-play': item.isPlay
      }
    }, [_c('div', [(item.isPlay) ? _c('img', {
      attrs: {
        "src": require("../../assets/mobile/icon/playing.svg"),
        "width": "16"
      }
    }) : _c('span', {
      staticClass: "track-list__item--number"
    }, [_vm._v(" " + _vm._s(index + 1))])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "text-poppins-16 font-weight-500 text-white"
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "text-poppins-14 font-weight-500 text-grey-5"
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])])])
  })], 2), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "track-list mb-2"
  }, [_c('div', {
    staticClass: "text-Poppins-15 font-weight-600 text-white mb-2"
  }, [_vm._v("Credits")]), _vm._v(" "), _vm._l((2), function(i) {
    return _c('div', {
      key: i,
      staticClass: "display-flex align-center justify-space-between gap-15 my-3"
    }, [_c('div', {
      staticClass: "display-flex align-center gap-15"
    }, [_c('img', {
      staticClass: "rounded",
      attrs: {
        "src": require("../../assets/mobile/notification_2.png"),
        "width": 40,
        "height": 40
      }
    }), _vm._v(" "), _vm._m(5, true)]), _vm._v(" "), _c('div', {
      staticClass: "text-poppins-12 text-black btn-follow font-weight-500 display-flex justify-center align-center"
    }, [_vm._v("\n        FOLLOW\n      ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "track-list mb-5"
  }, [_c('div', {
    staticClass: "text-Poppins-15 font-weight-600 text-white mb-2"
  }, [_vm._v("\n      283 comments\n    ")]), _vm._v(" "), _vm._l((2), function(i) {
    return _c('div', {
      key: i,
      staticClass: "display-flex align-center gap-15 my-3"
    }, [_c('img', {
      staticClass: "rounded",
      attrs: {
        "src": require("../../assets/mobile/notification_2.png"),
        "width": 40,
        "height": 40
      }
    }), _vm._v(" "), _vm._m(6, true)])
  }), _vm._v(" "), _c('input', {
    staticClass: "text-poppins-14 text-black mt-5 reply-input",
    attrs: {
      "placeholder": "Add your reply"
    }
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex align-center justify-center my-4"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/player.png"),
      "width": "329",
      "height": "326"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between align-start"
  }, [_c('div', [_c('div', {
    staticClass: "mb-1 text-poppins-18 text-white"
  }, [_vm._v("The Origin")]), _vm._v(" "), _c('div', {
    staticClass: "text-dmsans-14 font-weight-500 text-white"
  }, [_vm._v("SALVA")])]), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center gap-20"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/repeat.svg"),
      "width": "20"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/heart.svg"),
      "width": "20"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "progress-bar"
  }, [_c('span', {
    staticClass: "progress-line"
  }), _vm._v(" "), _c('input', {
    staticClass: "progress",
    attrs: {
      "type": "range",
      "min": "0",
      "max": "100",
      "value": "0",
      "id": "progress"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "duration mt-2 display-flex justify-space-between"
  }, [_c('span', [_vm._v("00:00")]), _vm._v(" "), _c('span', [_vm._v("-3:24")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-center align-center gap-42 my-5"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/previous.svg"),
      "width": "26"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/play-white.svg"),
      "width": "55"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/next.svg"),
      "width": "26"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-2 relative"
  }, [_c('img', {
    staticClass: "max-full-width username",
    attrs: {
      "src": require("../../assets/mobile/you.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "display-flex justify-space-between align-center pa-3 absolute w-100 top-0"
  }, [_c('div', [_c('div', {
    staticClass: "mb-1 text-poppins-18 text-white"
  }, [_vm._v("SALVA")]), _vm._v(" "), _c('div', {
    staticClass: "text-dmsans-14 font-weight-500 text-white"
  }, [_vm._v("Artist")])]), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-12 text-black btn-follow font-weight-500 display-flex justify-center align-center"
  }, [_vm._v("\n        Follow\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-poppins-16 font-weight-500 text-white"
  }, [_vm._v("Teeko")]), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-14 font-weight-500 text-white"
  }, [_vm._v("\n            producer\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-poppins-16 font-weight-500 text-white"
  }, [_vm._v("\n          Tame Impala\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-14 text-white"
  }, [_vm._v("this is amazing!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cbc0566","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/new-mobile/player.vue
// module id = 1608
// module chunks = 180